// extracted by mini-css-extract-plugin
module.exports = {"footer":"ContentBoxFooter_footer__1y203","footerContainer":"ContentBoxFooter_footerContainer__3znsv"};